// Shared constants, animation configs, and media URLs
import { 
  Target, Lightbulb, TrendingUp, Users, Award, Globe, 
  Cpu, Rocket, Brain, Building2, Shield, Star
} from "lucide-react";

// Media URLs
export const MEDIA = {
  hero: "https://static.prod-images.emergentagent.com/jobs/5de3e85a-28a1-4429-8023-48fbf8ee7c85/images/8f91ca88bf8874bc6500784432cd49bcc8dc713a5c3381e73f3315377d62987d.png",
  techTransform: "https://static.prod-images.emergentagent.com/jobs/5de3e85a-28a1-4429-8023-48fbf8ee7c85/images/3d6277d808e2b3e4a79532e2dd0aa36af5f5cc14bed924d3e8a89e3ee14a2619.png",
  corporate: "https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBwcm9mZXNzaW9uYWxzJTIwb2ZmaWNlJTIwbWVldGluZ3xlbnwwfHx8fDE3NzQ3MjQ0MDR8MA&ixlib=rb-4.1.0&q=85",
  corporate2: "https://images.pexels.com/photos/7433840/pexels-photo-7433840.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  expertLeader: "https://customer-assets.emergentagent.com/job_qbic-enterprise-hub/artifacts/o5ea70bz_PK.jpg",
  gtmConsulting: "https://images.unsplash.com/photo-1758873269035-aae0e1fd3422?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxlbnRlcnByaXNlJTIwc3RyYXRlZ3klMjBidXNpbmVzcyUyMHBsYW5uaW5nJTIwZXhlY3V0aXZlJTIwcHJlc2VudGF0aW9ufGVufDB8fHx8MTc3NTMwNDg5OXww&ixlib=rb-4.1.0&q=85",
  digitalTransform: "https://images.unsplash.com/photo-1639066648921-82d4500abf1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxzZXJ2ZXIlMjByYWNrcyUyMHRlY2hub2xvZ3klMjBjbG91ZCUyMGNvbXB1dGluZ3xlbnwwfHx8fDE3NzUzMDUxMTF8MA&ixlib=rb-4.1.0&q=85",
  contactPage: "https://images.unsplash.com/photo-1769069920097-1ab370ab35b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxjb250YWN0JTIwdXMlMjBidXNpbmVzcyUyMG9mZmljZSUyMGNvbW11bmljYXRpb24lMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzc1MzA0ODkyfDA&ixlib=rb-4.1.0&q=85",
};

const HI = (u) => `${u}${u.includes("?") ? "&" : "?"}w=1920&q=80`;
export const HERO_IMAGES = {
  about: HI("https://images.unsplash.com/photo-1572021335469-31706a17aaef?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0"),
  services: HI("https://images.unsplash.com/photo-1532622785990-d2c36a76f5a6?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0"),
  programs: HI("https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0"),
  aiCatalyst: "https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&w=1920",
  events: HI("https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0"),
  contact: "https://images.pexels.com/photos/7792841/pexels-photo-7792841.jpeg?auto=compress&cs=tinysrgb&w=1920",
  aiCoe: HI("https://images.unsplash.com/photo-1785682117028-6fcf2c0b515b?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0"),
};

// Animation variants (extracted to module level to avoid re-creation)
export const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 }
};

export const staggerContainer = {
  animate: { transition: { staggerChildren: 0.1 } }
};

// Viewport config (single object to avoid inline re-creation)
export const viewportOnce = { once: true };

// Static data arrays
export const HOME_STATS = [
  { id: 'stat-cities', end: 50, suffix: "+", label: "Cities Covered", icon: Globe },
  { id: 'stat-sessions', end: 125, suffix: "+", label: "Expert Sessions", icon: Users },
  { id: 'stat-trained', end: 1500, suffix: "+", label: "Professionals Trained", icon: Award },
  { id: 'stat-clients', end: 13, suffix: "+", label: "Enterprise Clients", icon: Building2 },
];

export const HOME_PRINCIPLES = [
  {
    id: 'principle-excellence',
    icon: Target,
    title: "Achieving Excellence",
    desc: "We equip individuals to excel by combining strategic foresight, meticulous planning, and hands-on expertise."
  },
  {
    id: 'principle-change',
    icon: Lightbulb,
    title: "Catalyst for Change",
    desc: "Leveraging cutting-edge technology and innovative thinking, we transform challenges into opportunities."
  },
  {
    id: 'principle-growth',
    icon: TrendingUp,
    title: "Cultivating Growth",
    desc: "Our solutions inspire a culture of continuous learning, turning obstacles into stepping stones."
  }
];

export const HOME_PROGRAMS = [
  {
    id: 'prog-ebyb',
    title: "Explore Beyond Your Boundaries\u2122",
    desc: "Sales enablement program focusing on advanced selling skills and professional excellence.",
    icon: Rocket
  },
  {
    id: 'prog-ai-catalyst',
    title: "AI Catalyst\u2122",
    desc: "Demystifying AI through comprehensive, beginner-to-advanced programs for practical learning.",
    icon: Brain
  },
  {
    id: 'prog-intel-unnati',
    title: "Intel\u00AE Unnati Partnership",
    desc: "Bringing world-class AI education and infrastructure to institutions in collaboration with Intel.",
    icon: Cpu
  }
];

export const WHY_CHOOSE_US = [
  { id: 'why-iso', icon: Shield, title: "ISO 27001:2022 Certified", desc: "Demonstrating trust and security in every aspect" },
  { id: 'why-global', icon: Globe, title: "Global Expertise", desc: "Serving clients across the world with impactful solutions" },
  { id: 'why-sme', icon: Users, title: "Experienced SMEs", desc: "Industry experts guiding every step of the journey" },
  { id: 'why-custom', icon: Star, title: "Customized Programs", desc: "Tailored solutions to meet your unique goals" },
];
